import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { LoggerService } from '@core/services/logger.service';

function logServerError(logger: LoggerService, err: HttpErrorResponse): void {
  if (err.status >= 500) {
    logger.error(`HTTP ${err.status} ${err.statusText}`);
    return;
  }
  if (err.status === 401) {
    logger.debug('HTTP 401 received');
    return;
  }
  if (err.status >= 400) {
    logger.warn(`HTTP ${err.status} ${err.url ?? ''}`);
  }
}

/** Central HTTP error logging, replacing ad-hoc catch blocks in v16 API service. */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        logServerError(logger, error);
      } else {
        logger.error('Non-HTTP error in request pipeline', error);
      }
      return throwError(() => error);
    }),
  );
};
